import { render, staticRenderFns } from "./ShoppingListV1.vue?vue&type=template&id=0060572b&scoped=true"
import script from "./ShoppingListV1.vue?vue&type=script&lang=js"
export * from "./ShoppingListV1.vue?vue&type=script&lang=js"
import style0 from "./ShoppingListV1.vue?vue&type=style&index=0&id=0060572b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0060572b",
  null
  
)

export default component.exports